var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { staticClass: "preview-modal-backdrop", on: { click: _vm.close } },
        [
          _c(
            "div",
            {
              staticClass: "preview-modal",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("div", { staticClass: "preview-modal-header" }, [
                _c(
                  "div",
                  { staticClass: "file-info" },
                  [
                    _c("feather-icon", {
                      staticClass: "file-icon",
                      attrs: { icon: _vm.getIconForFile(_vm.file), size: "18" }
                    }),
                    _c("span", { staticClass: "file-name" }, [
                      _vm._v(_vm._s(_vm.file.name))
                    ])
                  ],
                  1
                ),
                _c("div", { staticClass: "preview-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "action-button",
                      attrs: { title: "Download" },
                      on: { click: _vm.download }
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "DownloadIcon", size: "16" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "action-button",
                      attrs: { title: "Fechar" },
                      on: { click: _vm.close }
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "XIcon", size: "16" }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "preview-modal-body" },
                [
                  _c("file-preview", {
                    attrs: { file: _vm.file, "preview-url": _vm.previewUrl }
                  })
                ],
                1
              )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }